export default [
    {
        path: '/operations',
        name: 'operations',
        meta: {
            isSection: true
        },
        component: () => import('@/views/operation-list/index.vue')
    },
    {
        path: '/operations/add',
        name: 'operations_add',
        component: () => import('@/views/operation-details/index.vue')
    },
    {
        path: '/operations/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'operations_uuid',
                component: () => import('@/views/operation-details/index.vue'),
                props: route => ({ id: route.params.uuid })
            },
            {
                path: 'edit',
                name: 'operations_uuid_edit',
                component: () => import('@/views/operation-details/index.vue')
            },
            {
                path: 'related-operations-view',
                name: 'related_operations_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id, type: route.query.type }),
                meta: {
                    isView: true
                }
            },
            {
                path: 'operation-documentation-uuid-view',
                name: 'operation_documentation_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            },
            {
                path: 'view',
                name: 'operation_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
